<template>
    <div class="root">
        <div class="uploadbox">
          <div class="box-title">请拍摄并上传你的有效身份证</div>
          <div class="upload-list">
            <div v-if="applicant.idFrontFile[0]"  class="item">
              <img :src="applicant.idFrontFile[0].url" class="preview-cover">
              <div class="deleteimg" @click="applicant.idFrontFile=[]">删除</div>
            </div>
            <van-uploader
              v-else
              class="item"
              v-model="applicant.idFrontFile"
              :after-read="afterReadID1"
              :preview-full-image="false"
              :max-count=1
              capture="camera"
            >
              <template #default>
               <div  class="btn">
                  <img src="static/images/face.png">
                  <div class="type">上传身份证正面</div>
               </div>
              </template>
            </van-uploader>
            <div v-if="applicant.idBackFile[0]"  class="item">
              <img :src="applicant.idBackFile[0].url" class="preview-cover">
              <div class="deleteimg" @click="applicant.idBackFile=[]">删除</div>
            </div>
            <van-uploader
              v-else
              class="item"
              capture="camera"
              v-model="applicant.idBackFile"
              :after-read="afterReadID2"
              :preview-full-image="false"
              :max-count=1
            >
              <template #default>
                <div class="btn">
                  <img src="static/images/back.png">
                  <div class="type">上传身份证反面</div>
                </div>
              </template>
            </van-uploader>
          </div>
        </div>
        <div class="uploadbox margin-top">
          <div class="box-title">拍摄身份证要求：</div>
          <div class="text">
            <div>大陆公民持有的本人有效二代身份证；</div>
            <div>拍摄时确保身份证<span style="color:#FF0000">边框完整，字体清晰，亮度均匀；</span></div>
          </div>
          <img src="static/images/Group 35.png" class="tips-img">
        </div>
        <div class="uploadbox margin-top">
          <div class="box-title">请确认你的身份信息(自动识别)</div>
          <div class="idcard margin-top">
            <div class="text-item">
              <span>姓名</span>
              <span>{{ruleForm.name}}</span>
            </div>
            <div class="text-item">
              <span>身份证号</span>
              <span>{{ruleForm.certNo}}</span>
            </div>
            <div class="text-item">
              <span>有效期</span>
              <span>{{ruleForm.endDate}}</span>
            </div>
          </div>
        </div>
        <div class="submit-btn margin-top margin-bottom"  @click="handleBindCard" >提交</div>
    </div>
</template>
<script>
  import * as imageConversion from 'image-conversion'
    export default {
        name: "bulu",
        data() {
            return {
                step:'',
                showCert:0,
                imageList: [],
                newOCRXT: true, // 嵌入新ocr系统标识
                businessNo: "", // ocr系统业务号
                applicant: {
                  idBackFile:[],
                  idFrontFile:[]
                },
                fileList:{},
              isWhite:false,
              inputNumber:'',
                iccid: '',
                cardLengthCheck:false,
                errMsg: "",
                cardCheckOK:false,
                wxReady:false,
                sms:false,
                binded:false,
                bindInfo:{},
                needAuth:1,
                smsBtnTxt:'获取验证码',
                ruleForm:{
                    iccid:'',
                    mobile:'',
                    name:'',
                    code:''
                },
              showVerify:false,
              trueMobile:'',
              openid:'',
            };
        },
        methods: {

            handleBindCard(){
                if(!this.ruleForm.certNo) return  this.$toast("请先上传身份证");
                this.$toast.loading('提交中')
                this.ruleForm.iccid = this.iccid
                this.fetchDataPost('/card/bulu',this.ruleForm,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg);
                        this.$router.push({name:'home',query:{iccid:this.iccid}})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },

            afterReadID1(file){
                this.uploadimg(file,'idFrontFile');

            },
            afterReadID2(file){
                this.uploadimg(file,'idBackFile');
            },
            uploadimg(file,key) {
                this.applicant[key] = [
                    {
                        url:file.content,
                        isImage:true,
                        status:'uploading'
                    }
                ]
                imageConversion.compressAccurately(file.file, 1536).then(blob => {
                    let uploadfile = new window.File([blob], file.file.name, file)
                    this.$toast.loading({ forbidClick: true, duration:0})
                    this.upload("/base/uploadIDCard",{file:uploadfile},{type:key},res=>{
                        this.$toast.clear();
                        if(res.code){
                          let data = Object.assign(this.ruleForm,res.data)
                          this.$set(this.ruleForm, data)
                            this.applicant[key][0].status = 'done'
                            this.$forceUpdate()
                        }else{
                            this.applicant[key][0].status = 'failed'
                            this.$toast(res.msg)
                        }
                    })
                });
            },
            // 上传参数
            uploadParams(type, imageUrl) {
                let pamasImg = {
                    type,
                    imageUrl,
                };
                if (this.imageList.length > 0) {
                    for (let i = 0; i < this.imageList.length; i++) {
                        if (this.imageList[i].type == type) {
                            this.imageList.splice(i, 1);
                        }
                    }
                }
                this.imageList.push(pamasImg);
            },

        },
        created: function () {
            this.iccid = this.$route.query.iccid
        }
    };
</script>
<style lang="scss" scoped>

  .margin-top{
    margin-top: .32rem!important;
  }.margin-bottom{
    margin-bottom:  .32rem!important;
  }
  .uploadbox{
    padding: .32rem;
    width: 6.86rem;
    background: #fff;
    border-radius: .4rem;
    .idcard{
      div{

        width: 98%;
        display: flex;
        margin: auto;
        border-bottom: 1px solid #ADA9A9;;
        span{
          font-size: .26rem;
          line-height: .60rem;
          display:block;
          flex: 1;
        }
        span:first-child{
          flex: 1;
          font-weight: 500;
          text-align: left;
          color: #000;
        }
        span:last-child{
          flex: 1.5;
          font-weight: 500;
          text-align: right;
          color: #ADA9A9;
        }
      }
    }
    .tips-img{
      width: 6.82rem;
      display: block;
      margin: 0 auto;
    }
    .text{
      margin: .32rem 0;
      div{
        font-weight: 500;
        font-size: .26rem;
        color: #000;
        line-height: .40rem;
      }
    }
    .box-title{
      color: #ADA9A9;
      font-size: .30rem;
    }
    .upload-list{
      width: 6.86rem;
      margin: .27rem auto;
      display: flex;
      .item{
        position: relative;
        flex: 1;
        width: 3.27rem;
        border-radius: .1rem;
        overflow: hidden;
          .preview-cover{
            margin: 0!important;
            width: 3.27rem;
            height: 2.22rem;
          }
        .deleteimg{
          text-align: center;
          color: #fff;
          height: .54rem;
          line-height: .54rem;
          font-size: .30rem;
          background: #ff2c27;
        }
        .btn{
          img{
            display: block;
            margin: 0 auto;
          }
          .type{
            text-align: center;
            color: #fff;
            height: .54rem;
            line-height: .54rem;
            font-size: .30rem;
            background: #5580FC;
          }
        }

      }
      .item:last-child{
        margin-left: .27rem;
      }
    }
  }
  .submit-btn{
    margin: 0 auto;
    text-align: center;
    color: #fff;
    width: 6.42rem;
    height: .82rem;
    font-weight: 400;
    font-size: .30rem;
    line-height: .82rem;
    background: #2B7DFF;
    border-radius: .2rem;
  }
  .upload_ocr_upload {
    display: flex;
    justify-content: space-between;

    .upload_ocr_upload_box {
      text-align: center;

      .van-uploader__preview-image {
        width: 110px !important;
        height: 80px !important;
      }
    }

    .van-cell {
      padding-left: 0px;
      padding-right: 0px;
    }
  }


  .root{
    background: #f8f8f8;
    height: 100%;
    font-size: 0;
    .logo{
      margin: 0 auto;padding:0;display: block;width: .8rem
    }
    .bottom-tips-radius{
      border-radius: .32rem;
    }
    .bottom-tips{
      padding: .45rem .45rem 0;
      background: #fff;
      border-top-left-radius: .4rem;
      border-top-right-radius: .4rem;
      .title{
        font-weight: bold;
        color: #242424;
        font-size: .26rem;
        line-height: 0.48rem;
        text-align: left;
      }
      li{
        color: #666666;
        line-height: .43rem;
        font-size: .24rem;
        text-align: left;
      }
    }
    .scancode{
      width: 100%;
      background: #fff;
      padding-top: .6rem;
      img{
        width: 4.92rem;
        margin: auto;
        display: block;
      }
    }
    .form{
      width: 7.5rem;
      background: #fff;
      border-radius: .4rem;
      margin: 0 auto .32rem;
      font-size: 0;
      padding: .32rem 0;
      line-height: .52rem;
      .input-group {
        display: flex;
        width: 6.42rem;
        margin: .32rem auto;
        padding: 0;
        .input-control{
          width: 6.42rem;
          position: relative;
          input{
            text-indent: .84rem;
            font-size: .3rem;
            width: 100%;
            padding: 0;
            margin: 0;
            border-radius: .4rem;
            border: none;
            background: #f8f8f8;
            color:#707070;
            font-weight: bolder;
            height: .9rem;
            line-height: .9rem;
          }
          .preaddon{
            position: absolute;
            left: .2rem;
            top: .224rem;
            width: .32rem;
          }
          .addon{
            font-weight: 500;
            color: #2A7DFF;
            position: absolute;
            right: .2rem;
            top: 0;
            height: .52rem;
            line-height: .9rem;
            font-size: .28rem;
            .scanicon{
              font-weight: bold;
              line-height: .9rem;
            }
          }
        }
      }
    }
  }
  .buzhou{
    background: #fff;
    border-radius: .4rem;
    margin-bottom: .32rem;
    display: flex;
    width: 5.1rem;
    padding: .4rem 1.2rem ;
    .item{
      width: .5rem;
      z-index: 1050;
      div:first-child{
        background: #D2D4DD;
        width: .5rem;
        height: .5rem;
        text-align: center;
        margin: 0 auto;
        line-height: .5rem;
        border-radius: .5rem;
        color: #fff;
        font-size: .32rem;
      }
      div:last-child{
        font-weight: bolder;
        font-size: .3rem;
        margin-left: -75%;
        white-space: nowrap;
        color: #D2D4DD;
      }
    }
    .item.active{
      div:first-child{
        background: #5487E2;
      }
      div:last-child{
        color: #5487E2;
      }
    }
    .xian{
      width: 4.3rem;
      height: 2px;
      margin: .25rem 2px;
      background: #D2D4DD;
    }
  }
  input::-webkit-input-placeholder {
    color:#cdd3e0;
    font-size: 0.26rem;
  }
  input:-moz-placeholder {
    color:#cdd3e0;
    font-size: 0.26rem;
  }
  input:-ms-placeholder {
    color:#cdd3e0;
    font-size: 0.26rem;
  }
  input:-o-placeholder {
    color:#cdd3e0;
    font-size: 0.26rem;
  }
  input:placeholder {
    color:#cdd3e0;
    font-size: 0.26rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bulu.vue